import React from 'react';

import { SvgIcon, SvgIconProps } from '@mui/material';

import { ReactComponent as Icon } from './WarningIcon.svg';

/**
 * @function
 * Auto-generated file.
 */
export const WarningIcon = React.forwardRef<SVGSVGElement, SvgIconProps>(function WarningIcon(props, ref) {
  return (
    <SvgIcon ref={ref} viewBox="0 0 25 22" component={Icon} {...props} />
  );
});
